/*
2017-09-26 NLD: Signage running in iframe in IE 11 will not function if calls
are made to console without developer tools open because console is not defined.
We will polyfill console then. This polyfill must occur very early in
application flow.
*/
if (typeof window.console === 'undefined') {
    window.console = {
        debug: function () {},
        info: function () {},
        log: function () {},
        warn: function () {},
        error: function () {},
    };
}
